export default "__VITE_ASSET__Bb9j1W54__"